import { createPinia } from "pinia";

// Create the root store
const pinia = createPinia();

// Persistence plugin
pinia.use(({ store }) => {
  // Run the store's hydrate method if it exists
  if (store.$state && "hydrate" in store && typeof store.hydrate === "function") {
    store.hydrate(store.$state);
  }
});

export default pinia;
